export const BLACK_FRIDAY_THEME = '#cfad59';
export const CHRISTMAS_THEME = '#d9c87a';
